import { setSessionItem } from "~/utils/sessionStorage";

export default defineNuxtPlugin((nuxtApp) => {
  const SCRIPT_ID = "cheq-script";

  const loadCheqScript = () => {
    // Don't load again if already present
    const existingScript = document.getElementById(SCRIPT_ID);
    if (existingScript) return;

    const storeCheqInputsToSession = () => {
      const tryStore = () => {
        const reqIdEl = document.getElementById("cq_req_id") as HTMLInputElement | null;
        const reqIpEl = document.getElementById("cq_req_ip") as HTMLInputElement | null;

        if (reqIdEl?.value) {
          setSessionItem("cq_req_id", reqIdEl.value);
        }

        if (reqIpEl?.value) {
          setSessionItem("cq_req_ip", reqIpEl.value);
        }
      };
      setTimeout(tryStore, 1000);
    };

    // Add new script
    const script = document.createElement("script");
    script.src = "https://ob.sd30591.asuonline.asu.edu/i/b19793e55420ad2efd2a0b2330366620.js";
    script.async = true;
    script.id = SCRIPT_ID;
    script.setAttribute("class", "ct_clicktrue_86061");
    script.setAttribute("data-ch", "PROD ASU Online");
    script.setAttribute("data-jsonp", "onCheqResponse");
    script.onload = () => {
      storeCheqInputsToSession();
    };

    document.head.appendChild(script);
  };

  nuxtApp.hook("page:finish", () => {
    loadCheqScript();
  });
});
